import { useEffect, useMemo, useState } from 'react';

import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';

import { formatDataOptions } from '../helper';

import NegoceFilters from '../components/NegoceFilter';
import ExportButton from '../../../components/Export/Button';
import Card from '../../../components/Card';
import CardHeader from '../../../components/CardHeader';
import Spinner from '../../../components/Spinner';
import SubmissionSummary from '../components/SubmissionSummary';

import {
  useFilters,
  useNegociantsSubmissions
} from 'apiTyped/hooks/submission.query';

const NegoceContainer = styled.div`
  .negoceRowContainer {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-gap: 25px;
  }

  .submissionsTable {
    margin-top: 20px;
  }
`;

const Submissions = () => {
  const [defaultCampaign, setDefaultCampaign] = useState(null);
  const [currentCampaign, setCurrentCampaign] = useState(null);

  const { isLoadingFilters, filters } = useFilters({});

  const { isLoadingData, data } = useNegociantsSubmissions({
    campaignId: currentCampaign
  });

  const loading = useMemo(
    () => isLoadingFilters || isLoadingData,
    [isLoadingFilters, isLoadingData]
  );

  useEffect(() => {
    if (!defaultCampaign) {
      const campaignDefaultOption = filters.campaigns.find(
        ({ is_default }) => is_default === true
      );

      if (campaignDefaultOption) {
        setDefaultCampaign(campaignDefaultOption.campaign_id);
        setCurrentCampaign(campaignDefaultOption.campaign_id);
      }
    }
  }, [filters]);

  const handleChangeCampaign = async (selectCampaign) => {
    const campaignId =
      selectCampaign !== null ? selectCampaign.value : defaultCampaign;
    setCurrentCampaign(campaignId);
  };

  const campaignsData = filters.campaigns || [];
  const options = formatDataOptions(campaignsData, {
    value: 'campaign_id',
    label: 'campaign_name'
  });

  return (
    <NegoceContainer>
      <Card>
        <div className="negoceRowContainer">
          <NegoceFilters
            campaignFilter={{
              selectedOption:
                options.find((item) => item.value === currentCampaign) ||
                options[0],
              options: options,
              onChange: (selectedOption) =>
                handleChangeCampaign(selectedOption),
              label: I18n.t('negoce.filters.date'),
              placeholder: I18n.t('negoce.filters.datePlaceholder')
            }}
          />
          <ExportButton
            options={['xls']}
            paths={{
              xls: `/negociant/campaign/${currentCampaign}/submissions`
            }}
            newApi
          />
        </div>
      </Card>
      <div className="submissionsTable">
        <Card>
          <CardHeader
            title={I18n.t('negoce.submissionsRecap.title')}
            fontSize="20px"
          />
          <SubmissionSummary
            wines={filters.wines}
            data={data.campaignSubmissionsStats}
          />
        </Card>
      </div>
      <Spinner loading={loading} />
    </NegoceContainer>
  );
};

export default Submissions;
